import { Injectable } from '@angular/core';
import { GeneralConstants } from '../constants/general.constants';
import { RefundPaymentModel } from '../models/refund-payment.model';
import { RestService } from './rest.service';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';
import { PaymentInfoModel } from '../models/payment-info.model';
import { getCurrencyValue, numberToCurrency } from 'src/app/shared/functions/currency.functions';

@Injectable({
  providedIn: 'root'
})
export class RefundPaymentService {
  constructor(
    private restService: RestService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  formatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP'
  });

  public getPaymentInfo = async (paymentId: number): Promise<PaymentInfoModel> => {
    try {
      const response = await this.restService.get(`${GeneralConstants.paymentInfo}/${paymentId}`);
      let payment = new PaymentInfoModel();
      payment.devoluciones = response.object.devoluciones;
      payment.monto = response.object.monto;
      payment.paymentId = response.object.paymentId;
      payment.saldo = this.formatter.format(response.object.saldo);
      payment.sumDevoluciones = response.object.sumDevoluciones;
      return payment;
    } catch (error) {
      console.log(error.message);
    }
  };

  public refusePayment = async (payment: RefundPaymentModel) => {
    try {
      const response = await this.restService.post(GeneralConstants.refundPayment, payment);
      this.notificationService.mgsView({
        error: null,
        messenger: response.message,
        title: 'Anulación de pago',
        type: 1,
        configNotification: null
      });
      this.router.navigate(['/user/movements']);
      return response;
    } catch (error) {
      /**
       *  Hago un parseInt del error para validar si el error es un ID de exception o un mensaje de error, en caso que sea ID
       *  no entra al IF y le creo un mensaje por default a la exception.
       */

      let errorType: any = parseInt(error.message);
      if (isNaN(errorType)) {
        return this.notificationService.mgsView({
          error: 404,
          messenger: error.message,
          title: 'Anulación de pago',
          type: 2,
          configNotification: null
        });
      }

      /**
       *   Mensaje por default en caso de que el error.message sea una exception, para no devolver el ID de la exception al usuario
       *   hice un mensaje por defecto hasta que se maneje el mensaje de exception bien en el BE (Backend)
       */

      this.notificationService.mgsView({
        error: 404,
        messenger: 'Ocurrió un error inesperado',
        title: 'Anulación de pago',
        type: 3,
        configNotification: null
      });
    }
  };
}
